import { Id } from '@vimeo/core/types/generic';
import { liveApplicationConfig } from '@vimeo/live-core/configs/LiveApplicationConfig';

/**
 * Create DOM element name in provided prefix context.
 *
 * @param prefix - prefix for creation of unique dom name
 * @param parts - parts of newly generated name
 * @deprecated - use live/core shared variant
 */
export function createDomName(prefix: Id, ...parts: Array<Id>): string {
  return `${prefix}-${parts.join('-')}`;
}

/**
 * Create name for live application DOM element.
 * If have extending parts just extend base, else just create new name.
 *
 * @deprecated - use live/core shared variant
 */
export function createLiveDomName(base: Id, ...extending: Array<Id>): string {
  return extending.length
    ? `${base}-${extending.join('-')}`
    : createDomName(liveApplicationConfig.DOM.LIVE_APP_NAMING_PREFIX, base, ...extending);
}

/**
 * Create name for interaction application DOM element.
 * If have extending parts just extend base, else just create new name.
 *
 * @deprecated - use live/core shared variant
 */
export function createInteractionDomName(base: Id, ...extending: Array<Id>): string {
  return extending.length
    ? `${base}-${extending.join('-')}`
    : createDomName(liveApplicationConfig.DOM.INTERACTION_APP_NAMING_PREFIX, base, ...extending);
}
